import useEducationReporting from './UseEducationReporting';

import ReportList from '@usas/ui-web/components/embeddedReports/ReportList';

const EducationReporting = () => {
  const { reportParameters, routeName } = useEducationReporting();
  
  return (
    <ReportList listTitle="Education Reports"
      routeName={routeName}
      reportParameters={reportParameters} />
  );
};

export default EducationReporting;